var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModality = function SvgModality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "modality_svg__path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__export",
    transform: "translate(-132 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__badges/modality",
    transform: "translate(132 251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__color/alexs-deep-blue/base-003595"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "modality_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#modality_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#modality_svg__path-1",
    id: "modality_svg__Mask",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__color/alexs-deep-blue/base-003595(og)",
    fill: "#003996",
    mask: "url(#modality_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__alexs-deep-blue-003595",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__noun_infographic_3427520",
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__Group",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Shape",
    d: "M9.443 7.992H.557C.25 7.992 0 7.73 0 7.404V.588C.001.263.25 0 .557 0h8.886C9.75 0 10 .263 10 .588v6.816c0 .325-.249.588-.556.588m-8.33-1.176h7.775v-5.64H1.112z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49 4.583h5.02V5.76H2.49zM2.49 2.233h5.02V3.41H2.49z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "modality_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Shape",
    d: "M6.745 6H.541C.242 6 0 5.73 0 5.396V.611C0 .277.242.007.54.007h6.205c.299 0 .541.27.541.604v4.785c0 .334-.242.604-.54.604M1.082 4.792h5.122V1.215H1.082z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Rectangle",
    d: "M1.983 2.399h3.321v1.208H1.983z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.555 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Shape",
    d: "M6.779 6H.574c-.298 0-.54-.27-.54-.604V.611c0-.334.242-.604.54-.604H6.78c.299 0 .54.27.54.604v4.785c0 .334-.241.604-.54.604M1.115 4.792h5.123V1.215H1.115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Rectangle",
    d: "M2.016 2.399h3.321v1.208H2.016z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Rectangle",
    d: "M8 7h1v2H8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "modality_svg__Path",
    d: "M14 12h-1.107v-1.936H4.107V12H3V9.532C3 9.238 3.248 9 3.554 9h9.892c.306 0 .554.238.554.532z"
  })))))));
};
export default SvgModality;